module.exports = __webpack_public_path__ + "media/images/features/3/plan-detail-background-feature3-3296468bf599d092c30fa4faea07dbea.jpg";